// CheckBox — the smallest primitive of the dashboard.
//
// Tap target is 44×44 (mobile-friendly) regardless of the small visual cell.
// State: "idle" (default), "done", "partial" (counter/timer in progress),
// "timer" (running), "frozen" (streak freeze marked).

import type { CSSProperties } from "react";

export type CheckBoxState = "idle" | "done" | "partial" | "timer" | "frozen";

interface Props {
  state: CheckBoxState;
  onToggle?: () => void;
  label?: string; // optional visible label inside the box (counter progress)
  ariaLabel: string;
  size?: number;
}

export function CheckBox({ state, onToggle, label, ariaLabel, size = 44 }: Props) {
  const glyph = (() => {
    switch (state) {
      case "done":    return "✓";
      case "partial": return label ?? "·";
      case "timer":   return "●";
      case "frozen":  return "❄";
      case "idle":    return " ";
    }
  })();
  const ariaState = state === "idle" ? "unchecked" : "checked";
  const style: CSSProperties = { width: size, height: size };
  return (
    <button
      type="button"
      className="shukan-checkbox"
      data-state={state}
      aria-label={ariaLabel}
      aria-checked={state !== "idle"}
      role="checkbox"
      style={style}
      onClick={onToggle}
    >
      <span aria-hidden="true">{glyph}</span>
    </button>
  );
}
